import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

interface Props {
  filters?: React.ReactNode;
  children?: React.ReactNode;
  filtersNode?: React.ReactNode;
  isPreviewMode?: boolean;
  filterStyle?: React.CSSProperties;
}
const ReportSummaryBase: React.FC<Props> = ({
  children,
  filters,
  filtersNode,
  isPreviewMode,
  filterStyle,
}) => {
  return (
    <div>
      <Box
        margin={{ top: 'spacing12' }}
        direction="column"
        pad="spacing24"
        round="container1Round"
        background="module"
      >
        {!!filtersNode && (
          <Text size="medium" weight={700}>
            Filters
          </Text>
        )}

        <Box direction="column" data-testid="report-summary_filters" style={{ ...filterStyle }}>
          {filtersNode ? (
            filtersNode
          ) : filters ? (
            <Box
              direction="column"
              margin={{ top: 'spacing8' }}
              round="container1Round"
              justify="stretch"
              border={isPreviewMode ? undefined : { size: 'small', color: 'border1' }}
              background={isPreviewMode ? undefined : 'canvas'}
              pad={isPreviewMode ? undefined : 'spacing12'}
            >
              <Box direction="row">{filters}</Box>
              {isPreviewMode && (
                <Text size="medium" weight={700} margin={{ top: 'spacing24' }}>
                  Results preview
                </Text>
              )}
            </Box>
          ) : (
            <Box margin={{ top: 'spacing8' }} />
          )}
        </Box>
        <Box margin={{ top: 'spacing12' }} direction="column">
          {children}
        </Box>
      </Box>
    </div>
  );
};
export default ReportSummaryBase;
